import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import TaskList from "../components/TaskList";

export default function TasksRewards({ children, events }) {
  const [listOpen, setListOpen] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target))
        setListOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <li ref={menuRef} className="relative">
      <span
        className="cursor-pointer flex items-center gap-[2px]"
        onClick={() => setListOpen(!listOpen)}
      >
        {children || "任務與獎勵"}
        <IoIosArrowDown
          size={16}
          className={`${
            listOpen ? "rotate-180" : ""
          } transition-transform duration-300`}
        />
      </span>
      <AnimatePresence>
        {listOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 1.15 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 1 }}
            className="absolute top-[4rem] left-[-35%] z-10 bg-white shadow-[0_0_5px_rgba(0,0,0,0.16)] rounded-md overflow-hidden"
          >
            <TaskList events={events} />
          </motion.div>
        )}
      </AnimatePresence>
    </li>
  );
}
